import config from '../../config';
import { authHeader } from '../_helpers/auth-header';
import { createRequestCache } from '../Page/HomePage/floorDeckRequestCache';
import { DEFAULT_AVAILABLE_HOURS } from '../utils/utilizationTime';

// Company-wide scheduled available hours per machine per day.
const settingsCache = createRequestCache(60 * 1000);

async function readJson(response, fallbackMessage) {
    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
        const error = new Error((data && (data.error || data.message)) || fallbackMessage);
        error.status = response.status;
        throw error;
    }

    return data;
}

async function requestSettings(method, body) {
    const response = await fetch(`${config.apiUrl}/utilization-settings`, {
        method,
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
    });
    const data = await readJson(response, 'Unable to load utilization settings.');
    const hours = Number(data.availableHours);

    return {
        availableHours: hours > 0 ? hours : DEFAULT_AVAILABLE_HOURS,
    };
}

// The server reads the company from the credentials, so key the cache by them:
// a different signed-in user never sees another company's selection.
function settingsKey() {
    return authHeader().Authorization || '';
}

function getSettings() {
    return settingsCache.getStaleWhileRevalidate(settingsKey(), () => requestSettings('GET'));
}

async function saveSettings({ availableHours }) {
    const key = settingsKey();
    settingsCache.clear();

    try {
        const saved = await requestSettings('PUT', { availableHours });
        // Seed the cache with the confirmed value so the Floor Deck shows it at once.
        settingsCache.get(key, () => saved, true);
        return saved;
    } catch (error) {
        settingsCache.clear();
        throw error;
    }
}

export const utilizationSettingsService = {
    getSettings,
    saveSettings,
    clear: () => {
        settingsCache.clear();
    },
};
